/**
 *
 * @param {number} value Number value
 * @param {number} fractionDigits Number of fraction digits
 * @param {Object} options Options
 * @returns {string} Formatted number
 */
export const toFormattedNumber = (value, fractionDigits = 0, options = {}) =>
  value.toLocaleString('th-TH', {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
    ...options
  })
